import {
    CHANGE_DATE_START,
    CHANGE_DATE_END,
    CLEAR_FILTER_ALL
} from '../actions';

export const changeDateStart = (dateStart) => {
    return (
        {
            type: CHANGE_DATE_START,
            payload: dateStart
        }
    )
}

export const changeDateEnd = (dateEnd) => {
    return (
        {
            type: CHANGE_DATE_END,
            payload: dateEnd
        }
    )
}

export const clearFilterAll = (data) => {
    return (
        {
            type: CLEAR_FILTER_ALL,
            payload: data
        }
    )
}
